import { useState, useEffect, useRef } from 'react'
import VideoChat from './VideoChat'
import Messages from './Messages'
import History from './History'
import { Settings as SettingsIcon, Search, LeftArrow, VideoCamera, MailOpen, Play, Clock, Gift, Bell, Calendar, PhotoCamera, UserCheck, Loader } from 'assets/icons/components'
import Settings from './Settings'
import { connect } from 'react-redux'
import { HistoryServices, FriendServices } from 'services'
import { setMainContent, setIsFullScreen, setDocumentTitleMessages, setFriends, setFriendRequests } from 'actions'
import { addConversation, setActiveConversation, setConversations } from 'actions/chat'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import { setActiveSidebar, setMainContentMobile, setMinutePackagesModal, setNoticeModal, setQuickSettingsModal, setRankingsModal, setReferralModal, setRegisterModal, setStoriesModal, setTierModal, setUpgradeModal, setWeeklyBonusModal, setWithdrawModal, setYotiVerifyModal } from 'actions/mainContent'
import { Tooltip, OverlayTrigger, Modal } from 'react-bootstrap'
import { documentVerificationDestination, VERIFY_ON_PLATFORM } from 'ultils/documentVerificationRoute'

import {
  AccountAction,
  AccountActions,
  AccountBonus,
  AccountMinutes,
  AccountPremium,
  AccountPremiumWrapper,
  ListMenuDesktop,
  ListMenuItem,
  ListMenuMobile,
  PremiumPopupAction,
  PremiumPopupAmount,
  PremiumPopupBox,
  PremiumPopupContainer,
  PremiumPopupContent,
  PremiumPopupDesc,
  PremiumPopupExpires,
  PremiumPopupHeader,
  PremiumPopupKind,
  PremiumPopupName,
  PremiumQuestion,
  Unread,
  AccountTier,
  AccountBalance,
  BalanceSwap,
  BalancePoints,
  BalanceUsd,
  UnreadMobile,
  Count,
  CallPointsStatus,
  AvatarContainer,
  AccountGift,
  UserDropdownContainer,
  StatusContainer,
  Status,
  StatusChange,
  ProfileContainer,
  StatusTitle,
  StatusList,
  StatusCard,
  StatusInfo,
  StatusRadioIndicator,
  StatusDesc,
  StatusAction,
  StatusModalContent,
  StatusActionContainer,
  Action,
  ActionClose,
  CallPoints,
  CrownIcon,
  PremiumIcon,
  PremiumPopupMinutesBox,
  GetPremiumButton,
} from './style'
import moment from 'moment'
import { ModelServices, UserServices } from 'services/index'
import { ECHO_NEW_NOTICE } from 'constants/realtimeEvent'
import { setUser } from 'actions/connection'
import { toast } from 'components/common/Toast'
import Crown from 'assets/icons/components/Crown'

const Sidebar = (props) => {
  const { t } = useTranslation('live', { i18n })
  const { 
    user, dispatch, unread, activeSidebar,
    contentKey, contentKeyMobile, localStream,
    isShowNoticeModal, newEvent, activeReward, storiesModal
  } = props
  const [activeTab, setActiveTab] = useState('video-chat')
  const [currentActiveKey, setCurrentActiveKey] = useState(['recent-conversations'])
  const [isMessageLoaded, setIsMessageLoaded] = useState(false)
  const [totalNotices, setTotalNotices] = useState(0)
  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const [isShowStatusModal, setIsShowStatusModal] = useState(false)
  const [isShowPremiumPopup, setIsShowPremiumPopup] = useState(false)
  const [availableStatus, setAvailableStatus] = useState(user?.available_status)
  const [isLoading, setIsLoading] = useState(false)
  const dropdownRef = useRef(null)
  const premiumRef = useRef(null)
  // Earnings pill: points as shown, and the payout value they stand for
  // (100 points = $1), revealed on hover.
  const points = Math.floor(user?.balance || 0)

  useEffect(() => {
    switch (contentKeyMobile) {
      case 'history-mobile':
        setActiveTab('history-mobile')
        break;
      case 'message-mobile': 
        setActiveTab('messages')
        break;
      case 'settings-mobile':
        setActiveTab('settings')
        break;
      default:
        break;
    }
  }, [contentKeyMobile])

  useEffect(() => {
    if (contentKey !== 'dashboard' && activeTab === 'video-chat') {
      setActiveTab(null)
    }
  }, [contentKey])

  useEffect(() => {
    if (activeSidebar === 'messages' && activeSidebar !== activeTab || activeSidebar === 'settings' && activeSidebar !== activeTab) {
      setActiveTab(activeSidebar)
    }
  }, [activeSidebar])

  useEffect(() => {
    dispatch(setActiveSidebar(activeTab))

    switch(activeTab) {
      case 'video-chat':
        dispatch(setMainContent('dashboard'))
      break;
      case 'messages':
      break;
    }
    if (activeTab === 'messages' && !isMessageLoaded) {
      setIsMessageLoaded(true)
    }
  }, [activeTab])

  useEffect(() => {
    if (user?.role === 'user' && user?.gender === 1) {
      getTotalNotices()
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsShowDropdown(false)
    }
    if (premiumRef.current && !premiumRef.current.contains(event.target)) {
      setIsShowPremiumPopup(false)
    }
  }

  useEffect(() => {
    if (newEvent?.event === ECHO_NEW_NOTICE) {
      setTotalNotices(totalNotices + 1)
    }
  }, [newEvent])

  useEffect(() => {
    if (isShowNoticeModal) {
      setTotalNotices(0)
    }
  }, [isShowNoticeModal])

  const getTotalNotices = async () => {
    let { total } = await UserServices.getTotalNotices()

    setTotalNotices(total)
  }

  let tabs = [
    {
      key: 'video-chat',
      label: t('Video chat'),
      component: <VideoChat />
    },
    {
      key: 'messages',
      label: t('Messages'),
      component: <Messages
        setCurrentActiveKey={setCurrentActiveKey}
        currentActiveKey={currentActiveKey} />
    },
  ]

  const changeTab = () => {
    if (activeTab === 'settings') {
      setActiveTab('video-chat')
    } else {
      setActiveTab('settings')
    }
  }

  const handleRegister = () => {
    dispatch(setRegisterModal(true))
  }

  const handleLogin = () => {
    dispatch(setRegisterModal('login'))
  }

  const handleGetPremium = () => {
    dispatch(setUpgradeModal(true))
  }

  const handleGetMinutes = () => {
    if (user?.role === 'guest') {
      dispatch(setRegisterModal(true))
      return;
    }

    if (user?.account_tier !== 2) {
      dispatch(setUpgradeModal(true))
      return;
    }

    dispatch(setMinutePackagesModal(true))
  }

  const changeMainContent = () => {
    dispatch(setMainContent('dashboard'))
    if (localStream) {
      dispatch(setIsFullScreen(true))
    } else {
      dispatch(setIsFullScreen(false))
    }
    dispatch(setActiveConversation(null))
  }

  const onClickUser = () => {

    dispatch(setStoriesModal({
      isShow: false
    }))

    if (user?.role !== 'guest') {
      if (contentKey === 'personal-information') {
        dispatch(setMainContent('dashboard'))
        dispatch(setIsFullScreen(false))
      } else {
        dispatch(setMainContent('personal-information'))
        dispatch(setIsFullScreen(false))
      }
    } else {
      dispatch(setRegisterModal(true))
    }
  }

  const handleChangeContent = (content) => {
    handleCloseStoriesModal()
    dispatch(setMainContent('dashboard'))
    dispatch(setMainContentMobile(content))
    dispatch(setIsFullScreen(false))
    dispatch(setActiveConversation(null))
  }

  const handleClickSettings = () => {
    dispatch(setQuickSettingsModal(true))
  }

  const handleOpenBonus = () => {
    dispatch(setReferralModal(true))
  }

  const handleOpenTier = () => {
    dispatch(setTierModal(true))
  }

  const handleOpenWithdraw = () => {
    dispatch(setWithdrawModal(true))
  }

  const handleClickMonetization = () => {
    // Yoti is not offered where she is -- straight to the upload flow, with no
    // partner sheet in between offering something she cannot use.
    if (documentVerificationDestination(user) === VERIFY_ON_PLATFORM) {
      dispatch(setMainContent('monetization'))
      dispatch(setIsFullScreen(false))
      return
    }

    dispatch(setYotiVerifyModal(true))
  }

  const handleOpenNotice = () => {
    dispatch(setNoticeModal(true))
  }

  const handleOpenStoriesModal = () => {
    dispatch(setStoriesModal({
      isShow: !storiesModal?.isShow
    }))
  }

  const handleOpenRankings = () => {
    dispatch(setRankingsModal({
      isShow: true
    }))
  }

  const handleOpenGift = () => {
    dispatch(setWeeklyBonusModal(true))
  }

  const changeAvailableStatus = async (status) => {
    setAvailableStatus(status)
  }

  const updateAvailableStatus = async () => {
    setIsLoading(true)
    const res = await ModelServices.changeAvailabelStatus({ status: availableStatus })
    setIsLoading(false)
    setIsShowStatusModal(false)

    if (res?.available_status) {
      toast.success(t('Your status has been changed'))
      dispatch(setUser({ available_status: res.available_status }))
    }
  }

  const handleCloseStoriesModal = () => {
    dispatch(setStoriesModal({
      isShow: false
    }))
  }

  const onChangeContent = (tab) => {
    dispatch(setMainContent(tab))
    dispatch(setIsFullScreen(false))
  }

  return (
    <>
      <div className='sidebar__header'>
        <div className="list-actions">
          <ListMenuDesktop>
            {tabs.map(tab => (
              <div className={`tabs__tab ${activeTab === tab.key ? 'tabs__tab--active' : ''}`} key={tab.key} onClick={() => { handleCloseStoriesModal();setActiveTab(tab.key) }}>
                <div className='tab__label'>
                  {tab.label}
                  { tab.key === 'messages' && unread > 0 ? <Unread active={activeTab === tab.key}>{ unread }</Unread> : '' }
                </div>
              </div>
            ))}
            { user?.gender === 0 && user?.is_allow_stories
              ?
                <div className={`tabs__tab`} onClick={() => handleOpenStoriesModal()}>
                  <div className='tab__label'>
                    { t('Stories') }
                  </div>
                </div>
              : <></>
            }
            { user?.gender === 1 && user?.monetization_status === 3
              ?
                <div className={`tabs__tab`} onClick={() => handleOpenRankings()}>
                  <div className='tab__label'>
                    { t('Rankings') }
                  </div>
                </div>
              : <></>
            }
            <ListMenuItem
              onClick={() => handleClickSettings()}
            >
              <SettingsIcon />
            </ListMenuItem>
          </ListMenuDesktop>
          <ListMenuMobile>
              {
                contentKey !== 'dashboard'
                ?
                  <ListMenuItem onClick={() => handleChangeContent('dashboard')}>
                    <LeftArrow />
                  </ListMenuItem>
                : <></>
              }
              {
                contentKeyMobile !== 'dashboard' && contentKey === 'dashboard'
                ?
                  <ListMenuItem onClick={() => handleChangeContent('dashboard')}>
                    <VideoCamera />
                  </ListMenuItem>
                : <></>
              }
              
              {
                contentKeyMobile === 'dashboard' && contentKey === 'dashboard'
                ?
                  <ListMenuItem onClick={() => handleChangeContent('message-mobile')}>
                    <MailOpen />
                    { unread > 0 ? <UnreadMobile style={{ position: 'absolute', top: '5px', right: '3px'}}>{ unread }</UnreadMobile> : '' }
                  </ListMenuItem>
                : <></>
              }
              {

                user?.gender === 0 && user?.is_allow_stories
                ?
                  <ListMenuItem
                    onClick={() => handleOpenStoriesModal()}
                  >
                    <Play />
                  </ListMenuItem>
                : <></>
              }
              <ListMenuItem
                isMobileHide={true}
                onClick={() => handleClickSettings()}
              >
                <SettingsIcon />
              </ListMenuItem>
          </ListMenuMobile>
        </div>
        <div className='header__info'>
          { user?.role === 'guest' 
            ?
              <>
                {
                  user?.gender !== 1 && (
                    <AccountMinutes
                      onClick={() => handleGetMinutes()}
                      lowMinutes={user?.minutes_balance < 120}
                    >
                      <Clock /> { Math.round(user?.minutes_balance / 60) }
                    </AccountMinutes>
                  )
                }
                
                <a onClick={() => handleLogin()}className="link-action">{ t('Login') }</a>
                <span className="separate">/</span>    
                <a onClick={() => handleRegister()}className="link-action">{ t('Register') }</a>
              </>
            :
              <AccountActions>
                {
                  user?.gender === 1
                  ?
                    <>
                    {
                      user?.monetization_status === 3
                      ?
                        <>
                          {
                            activeReward
                            ?
                              <AccountGift
                                  onClick={() => handleOpenGift()}
                                >
                                  <Gift />
                                  { totalNotices > 0 ? <Count>{ totalNotices }</Count> : '' }
                              </AccountGift>
                            : <></>
                          }

                          <AccountGift mobile={true}
                            onClick={() => handleOpenRankings()}
                          >
                              TOP
                          </AccountGift>

                          <AccountBonus
                            onClick={() => handleOpenNotice()}
                          >
                            <Bell />
                            { totalNotices > 0 ? <Count>{ totalNotices }</Count> : '' }

                          </AccountBonus>
                          <AccountBalance
                            onClick={() => handleOpenWithdraw()}
                          >
                            <BalanceSwap>
                              <BalancePoints>{points}</BalancePoints>
                              <BalanceUsd>{`$${(points / 100).toFixed(2)}`}</BalanceUsd>
                            </BalanceSwap>
                          </AccountBalance>
                          <AccountTier
                            onClick={() => handleOpenTier()}
                          >
                            { user?.tier }
                          </AccountTier>
                        </>
                      :
                      <>
                        <AccountMinutes
                          onClick={() => handleClickMonetization()}
                        >
                          {t('Verify')}
                        </AccountMinutes>
                        {
                          user?.monetization_status === 2 ?
                            <AccountBonus
                              onClick={() => handleClickMonetization()}
                            >
                              { t('Verifying') }
                            </AccountBonus>
                          : user?.monetization_status === 1 ?
                            <AccountBonus
                              onClick={() => handleClickMonetization()}
                            >
                              { t('Upload document') }
                            </AccountBonus>
                          : <AccountAction
                            onClick={() => handleClickMonetization()}
                          >
                            { t('Free') }
                            </AccountAction>
                        }
                      </>
                    }
                    </>
                  :
                    <>
                      {
                        user?.account_tier !== 2
                        ?
                          <>
                            <AccountMinutes
                              onClick={() => handleGetMinutes()}
                              lowMinutes={user?.minutes_balance < 120}
                            >
                              <Clock /> { Math.round(user?.minutes_balance / 60) }
                            </AccountMinutes>
                            <GetPremiumButton
                              onClick={() => handleGetPremium()}
                            >
                              <CrownIcon><Crown /></CrownIcon> {t('Get Premium')}
                            </GetPremiumButton>
                          </>
                        :
                          <>
                            {
                              user?.minutes_balance < 300
                              ?
                                <AccountAction onClick={() => handleGetMinutes()}>
                                  {t('Minutes Low')}
                                </AccountAction>
                              :
                                <></>
                            }
                            
                            <AccountPremiumWrapper ref={premiumRef}>
                              <AccountPremium
                                onClick={() => setIsShowPremiumPopup(!isShowPremiumPopup)}
                              >
                                <CrownIcon><Crown /></CrownIcon> {t('Premium')}
                              </AccountPremium>
                              <PremiumPopupContainer isOpen={isShowPremiumPopup}>
                                <PremiumPopupHeader>
                                  <PremiumPopupName>
                                    <CrownIcon><Crown /></CrownIcon> {t('Premium')}
                                  </PremiumPopupName>
                                  <PremiumPopupExpires>
                                    <Calendar style={{ color: 'var(--pink)'}} /> {t('to')} <span style={{ color: 'var(--pink)'}}>{moment(user?.expires_at).format('MM/DD/YYYY')}</span>
                                  </PremiumPopupExpires>
                                </PremiumPopupHeader>
                                <PremiumPopupContent>
                                  <PremiumPopupBox>
                                    <PremiumIcon>
                                      <MailOpen />
                                    </PremiumIcon>
                                    <PremiumPopupAmount>
                                      { user?.messages_balance }
                                    </PremiumPopupAmount>
                                    <PremiumPopupKind>
                                      {t('Messages')}
                                    </PremiumPopupKind>
                                    <PremiumPopupDesc>
                                      { t('Spend minutes to get messages') }
                                      <OverlayTrigger
                                        placement='top'
                                        overlay={
                                          <Tooltip id={`tooltip-top`}>
                                            { t('{{messages}} message credit for every minute you spend.', { messages: '+0.5' }) } <br/>
                                            { t('Video chats or send gifts.') }
                                          </Tooltip>
                                        }>
                                        <span> ( <PremiumQuestion>?</PremiumQuestion> ) </span>
                                      </OverlayTrigger>
                                    </PremiumPopupDesc>
                                  </PremiumPopupBox>
                                  <PremiumPopupMinutesBox>
                                    <PremiumIcon>
                                      <Clock />
                                    </PremiumIcon>
                                    <PremiumPopupAmount>
                                      { Math.round(user?.minutes_balance / 60) }
                                    </PremiumPopupAmount>
                                    <PremiumPopupKind>
                                      {t('Minutes left')}
                                    </PremiumPopupKind>
                                    <PremiumPopupDesc>
                                      <PremiumPopupAction
                                        onClick={() => { setIsShowPremiumPopup(false); handleGetMinutes() }}
                                      >
                                        {t('Buy')}
                                      </PremiumPopupAction>
                                    </PremiumPopupDesc>
                                  </PremiumPopupMinutesBox>
                                </PremiumPopupContent>
                              </PremiumPopupContainer>
                            </AccountPremiumWrapper>
                          </>
                      }
                      
                    </>
                }
              </AccountActions>
          }
           
            <AvatarContainer className='info__avatar'
              active={user?.available_status === 'available'}
              style={{ backgroundImage: `url(${user?.avatar})` }}
              onClick={() => setIsShowDropdown(!isShowDropdown)}
              >
                {
                  isShowDropdown
                  ?
                    <UserDropdownContainer ref={dropdownRef} onClick={(e) => { e.stopPropagation(); setIsShowDropdown(false) }}>
                      <StatusContainer onClick={() => setIsShowStatusModal(true)}>
                        {user?.available_status === 'available' ? t('Available') : t('Not Available')} <Status active={user?.available_status === 'available'} />
                        <StatusChange >
                          {t('Change status')}
                        </StatusChange>
                      </StatusContainer>
                      {
                        user?.monetization_status === 3
                        ?
                          <>
                            <ProfileContainer onClick={() => handleOpenBonus()}>
                              <Gift /> {t('Referral {{percent}}', { percent: '10%' })}
                            </ProfileContainer>
                            <ProfileContainer onClick={() => onChangeContent('story')}>
                              <PhotoCamera /> {t('Story')}
                            </ProfileContainer>
                          </>
                        : <></>
                      }

                      <ProfileContainer onClick={() => handleClickSettings()}>
                        <SettingsIcon /> {t('Settings')}
                      </ProfileContainer>

                      <ProfileContainer onClick={() => onClickUser()}>
                        <UserCheck /> {t('My profile')}
                      </ProfileContainer>
                    </UserDropdownContainer>
                  : <></>
                }
                
            </AvatarContainer>
          
          
        </div>
        
      </div>
    {
      activeTab !== 'video-chat' && activeTab
      ?
        <div className={`live-container__sidebar ${['history-mobile', 'message-mobile', 'settings-mobile'].includes(contentKeyMobile) && contentKey === 'dashboard'
          ? 'live-container__sidebar--mobile-active' : ''}`}>
          <div
            className={`sidebar__search-button ${!['dashboard', 'search'].includes(contentKey) ? 'sidebar__search-button--show' : ''}`}
            onClick={() => changeMainContent()}>
            <Search className='search-button__icon' />
          </div>
          {
            activeTab === 'settings'
              ?
                <Settings setActiveTab={setActiveTab} />
              :
                <div className='sidebar__content'>
                  {(tabs.find(tab => tab.key === activeTab)).component}
                </div>
          }
        </div>
      :
      <></>
    }
    <Modal
      show={isShowStatusModal}
      onHide={() => setIsShowStatusModal(false)}
      size='md'
      centered
      backdrop={true}>
      <Modal.Body >
        <StatusModalContent>
          <StatusTitle>{t('Select your status')}</StatusTitle>

          <StatusList role="radiogroup" aria-label={t('Select your status')}>
            <StatusCard
              role="radio"
              tabIndex={0}
              aria-checked={availableStatus === 'available'}
              selected={availableStatus === 'available'}
              onClick={() => changeAvailableStatus('available')}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); changeAvailableStatus('available') } }}>
              <StatusInfo>
                <StatusAction selected={availableStatus === 'available'}>
                  <Status active={true} /> {t('Available')}
                </StatusAction>
                <StatusDesc>{t('You are available for direct calls')}</StatusDesc>
              </StatusInfo>
              <StatusRadioIndicator selected={availableStatus === 'available'} />
            </StatusCard>

            <StatusCard
              role="radio"
              tabIndex={0}
              aria-checked={availableStatus === 'not-available'}
              selected={availableStatus === 'not-available'}
              onClick={() => changeAvailableStatus('not-available')}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); changeAvailableStatus('not-available') } }}>
              <StatusInfo>
                <StatusAction selected={availableStatus === 'not-available'}>
                  <Status active={false} /> {t('Not Available')}
                </StatusAction>
                <StatusDesc>{t("You are invisible so won't receive calls")}</StatusDesc>
              </StatusInfo>
              <StatusRadioIndicator selected={availableStatus === 'not-available'} />
            </StatusCard>
          </StatusList>

          <StatusActionContainer>
            <ActionClose onClick={() => setIsShowStatusModal(false)}>
              {t('Close')}
            </ActionClose>
            <Action
              onClick={() => updateAvailableStatus()}
              disabled={isLoading}
              aria-busy={isLoading}>
              { isLoading ? <Loader /> : null } <span>{ t('Save') }</span>
            </Action>
          </StatusActionContainer>
        </StatusModalContent>
      </Modal.Body>
    </Modal>
    </>
  )
}

const mapStateToProps = (state) => ({
  contentKey: state.mainContentReducer.contentKey,
  contentKeyMobile: state.mainContentReducer.contentKeyMobile,
  user: state.connectionReducer.user,
  conversation: state.chatReducer.conversation,
  unread: state.chatReducer.unread,
  localStream: state.videoCallReducer.localStream,
  documentTitle: state.mainContentReducer.documentTitle,
  allConversations: state.chatReducer.conversations,
  activeSidebar: state.mainContentReducer.activeSidebar,
  activeConversation: state.chatReducer.activeConversation,
  isShowNoticeModal: state.mainContentReducer.isShowNoticeModal,
  newEvent: state.echoReducer.newEvent,
  activeReward: state.mainContentReducer.activeReward,
  storiesModal: state.mainContentReducer.storiesModal,
})

export default connect(mapStateToProps)(Sidebar)